import React, { useEffect } from "react";
import { any } from "prop-types";

import { PopupButton } from "@typeform/embed-react";

import CoverPorfolio from "../../components/cover-portfolio";

import { LargeText, SmallTitle } from "../../ui-components/texts";

// import PeopleOfMasamune from "../../components/people-of-masamune";
import { DetailsProject } from "../../components/portfolio-components";
import { Column, Container, ContainerBlock } from "../../ui-components/columns/components";

// images
import imageCover from "../../media/images/portfolio-images/us-lecce/image-cover.jpg";
import testSquare from "../../media/test-image-square.jpg";
import { ThreeImagesWithDescription } from "./components-design";
import { FullWidthVideo } from "../../ui-components/videos";
import { useTranslate } from "../../contexts/translate";

const Peasy = ({ setNextPageHref = () => { }, setNextPageName = () => { } }) => {
	useEffect(() => {
		setNextPageHref("/projects/rica");
		setNextPageName("Rica");
		document.title = 'Peasy - Cutting Edge Digital Creative Studio'
	}, []);

	const { translations } = useTranslate();

	// const peoples = [
	// 	{
	// 		image: testSquare,
	// 		fullname: "Andrea Anfuso",
	// 		role: "CEO & Founder",
	// 		description:
	// 			"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nemo odit consectetur reprehenderit recusandae facilis, voluptate minima fuga reiciendis possimus inventore molestias distinctio earum unde commodi atque dignissimos. Placeat, unde a!",
	// 	}
	// ];

	return (
		<div className="project-page project-page-ohoskin">
			<CoverPorfolio
				background="#ffe7eb"
				title="Peasy"
				text={translations && translations.peasy.intro}
				image={require('../../media/images/portfolio-images/peasy/image-cover.jpg').default}
			/>

			<DetailsProject
				client={"Peasy"}
				services={["Brand Identity", "E-commerce"]}
				timeframe={"2020"}
				introduction={
					<>
						<LargeText>
							{translations && translations.peasy.descriptions[0]}
						</LargeText>
						<LargeText>
							{translations && translations.peasy.descriptions[1]}
						</LargeText>
						<LargeText>
							{translations && translations.peasy.descriptions[2]}
						</LargeText>
					</>
				}
			/>

			<ThreeImagesWithDescription
				color="#FFC0CB"
				imageLeft={require('../../media/images/portfolio-images/peasy/image-1.jpg').default}
				images={[{ src: require('../../media/images/portfolio-images/peasy/gallery/1.jpg').default }, { src: require('../../media/images/portfolio-images/peasy/gallery/2.jpg').default }, { src: require('../../media/images/portfolio-images/peasy/gallery/3.jpg').default }]}
				title={translations && translations.peasy.sections[0].title}
				texts={[
					translations && translations.peasy.sections[0].text
				]}
			/>

			<section
				className="theme-light mid-padding"
				style={{ background: "#fff" }}
			>
				<Container>
					<div className="wrapper fluid align-items-center">
						<Column className="w-50">
							<SmallTitle>{translations && translations.peasy.sections[1].title}</SmallTitle>
							<LargeText>
								{translations && translations.peasy.sections[1].text}
							</LargeText>
						</Column>
						<Column className="w-50">
							<img src={require('../../media/images/portfolio-images/peasy/image-2.jpg').default} alt="" />
						</Column>
					</div>
				</Container>

				<ContainerBlock className="fluid mt-5" style={{ padding: '0 50px' }}>
					<FullWidthVideo srcVideo={require('../../media/images/portfolio-images/peasy/video.mp4').default} previewImage={require('../../media/images/portfolio-images/peasy/preview-video.jpg').default} />
				</ContainerBlock>
			</section>
					<div className="cta-single-project">
				<div className="cta-single-project-inner">
					<p>{translations && translations.ctasingleproject.text}</p>
					<button
						className="leadconnector-button"
						onClick={() => {
							const overlay = document.createElement("div");
							overlay.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													background-color: rgba(0, 0, 0, 0.7);
													backdrop-filter: blur(5px);
													z-index: 9998;
												`;

							const modal = document.createElement("div");
							modal.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													z-index: 9999;
												`;

							const closeBtn = document.createElement("button");
							closeBtn.innerHTML = "✕";
							closeBtn.style.cssText = `
													position: fixed;
													top: 30px;
													right: 30px;
													width: 50px;
													height: 50px;
													border: none;
													background-color: rgba(255, 255, 255, 0.2);
													color: white;
													border-radius: 50%;
													cursor: pointer;
													font-size: 28px;
													z-index: 10000;
													transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
													backdrop-filter: blur(10px);
													border: 1px solid rgba(255, 255, 255, 0.3);
													display: flex;
													align-items: center;
													justify-content: center;
												`;
							closeBtn.onmouseover = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
								closeBtn.style.transform = "scale(1.15) rotate(90deg)";
								closeBtn.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.3)";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.5)";
							};
							closeBtn.onmouseout = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
								closeBtn.style.transform = "scale(1) rotate(0deg)";
								closeBtn.style.boxShadow = "none";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.3)";
							};
							closeBtn.onclick = () => {
								overlay.style.opacity = "0";
								modal.style.opacity = "0";
								overlay.style.transition = "opacity 0.4s ease-out";
								modal.style.transition = "opacity 0.4s ease-out";
								setTimeout(() => {
									document.body.removeChild(overlay);
									document.body.removeChild(modal);
								}, 400);
							};

							const iframe = document.createElement("iframe");
							iframe.src =
								"https://api.leadconnectorhq.com/widget/survey/fXRdOm9p3aM4iNGpHfOa?notrack=true";
							iframe.style.cssText = `
													width: 100%;
													height: 100%;
													border: none;
												`;
							iframe.allowFullscreen = true;

							modal.appendChild(iframe);
							modal.appendChild(closeBtn);
							document.body.appendChild(overlay);
							document.body.appendChild(modal);

							overlay.onclick = () => {
								document.body.removeChild(overlay);
								document.body.removeChild(modal);
							};
						}}
					>
						{translations && translations.ctasingleproject.button}
					</button>
				</div>
			</div>
		</div>
	);
};

Peasy.propTypes = {
	setNextPageHref: any,
	setNextPageName: any,
};

export default Peasy;
